import React from "react";
import { Box, Typography, Chip, Grid, Button, TextField, IconButton, Paper } from "@mui/material";
import { useSelector } from "react-redux";
import MicIcon from "@mui/icons-material/Mic";
import CloudDownloadIcon from "@mui/icons-material/CloudDownload";
import SelectableRadioGroupManager from "../../../selectable-radio-group-manger";

const strategies = [
  "Details of debrief ",
  "Could this incident have been avoided ? ",
  "Concerns raised",
  "Lessons learnt",
  "Support offered",
  "Actions to prevent immediate reoccurrence & allocated to",
];

const StaffMemberManager = ({ memberData, handleSubmit, prevStep, selectedStaff }) => {
  const user = useSelector((state) => state.auth.user); // User data from Redux store

  const allowedBehaviors = memberData?.map((b) => b.behavior);

  return (
    <Box sx={{ pl: 4, pr: 4, ml: 2 }}>
      <Chip
        variant='contained'
        sx={{
          fontSize: "14px",
          backgroundColor: "#F2F6FF",
          color: "blue",
        }}
        label='Daily Log'
        size='small'
      />
      <Typography sx={{ fontSize: "24px", color: "black", fontWeight: "bold" }}>Staff Debrief</Typography>
      <Typography variant='subtitle2' sx={{ color: "#757575" }}>
        Date: {new Date().toLocaleDateString()} &nbsp; • &nbsp;{" "}
        <span style={{ color: "#1751D0" }}>{user.username}</span>
      </Typography>
      <Box sx={{ borderBottom: "1px solid #E0E0E0", mt: 2, mb: 2 }} />

      <Grid container spacing={2}>
        <Grid item lg={8}>
          <Typography sx={{ fontSize: "16px", fontWeight: "bold", color: "#333", mb: 2 }}>Staff Debrief</Typography>
          <Grid container spacing={2} mb={3}>
            <Grid item lg={6}>
              <TextField
                value={selectedStaff || ""}
                fullWidth
                InputProps={{
                  readOnly: true,
                }}
              />
            </Grid>
          </Grid>
          <SelectableRadioGroupManager options={strategies} allowedOptions={allowedBehaviors} />
        </Grid>
        <Grid item lg={4} md={4}>
          {/* Incident Management Details Section - Recorded Entries */}
          <Box sx={{ mt: 4 }}>
            <Typography sx={{ fontSize: "14px", color: "black", fontWeight: "bold", mb: 2 }}>
              Incident Management
            </Typography>
            <Typography sx={{ fontSize: "14px", mb: 3 }}>Behavior Records</Typography>

            {memberData.map((record, index) => (
              <Paper
                key={index}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  padding: 1,
                  mb: 1,
                  borderRadius: 2,
                  border: "1px solid #ccc",
                }}
              >
                <Typography sx={{ fontSize: "14px", color: "black" }}>
                  {record.audio ? (
                    record.behavior
                  ) : (
                    <>
                      {record.behavior}
                      <br />
                      {record.note}
                    </>
                  )}
                </Typography>

                <Box>
                  {record.audio && (
                    <>
                      <IconButton onClick={() => window.open(record.audio, "_blank")}>
                        <MicIcon color='primary' />
                      </IconButton>
                      <IconButton onClick={() => window.open(record.audio, "_blank")}>
                        <CloudDownloadIcon color='primary' />
                      </IconButton>
                    </>
                  )}
                </Box>
              </Paper>
            ))}
          </Box>
        </Grid>
      </Grid>

      {/* Footer Actions */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2 }} mt={3}>
        <Button variant='outlined' color='primary' onClick={prevStep}>
          Previous
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={() => {
            handleSubmit();
          }}
        >
          Close
        </Button>
      </Box>
    </Box>
  );
};

export default StaffMemberManager;
